export const ChannelId = {
  WhatsApp: 'WhatsApp',
  FacebookMessenger: 'FacebookMessenger',
  WebChat: 'WebChat',
  Email: 'Email',
  ChannelsBar: 'ChannelsBar',
};
